import {
    dehydrate,
    hydrate,
    type DehydratedState,
    QueryClient,
    VueQueryPlugin,
    type VueQueryPluginOptions
} from "@tanstack/vue-query";

export default defineNuxtPlugin((nuxt) => {
    const vueQueryState = useState<DehydratedState | null>('vue-query')

    // Modify your Vue Query global settings here
    const queryClient = new QueryClient({
        defaultOptions: { queries: { staleTime: 1000 } },
    })
    const options: VueQueryPluginOptions = { queryClient }

    nuxt.vueApp.use(VueQueryPlugin, options)

    // Hydrate data from localStorage
    nuxt.hooks.hook("app:created", () => {
        const savedState = JSON.parse(localStorage.getItem("vue-query") || '{}')
        if (savedState) {
            try {
                hydrate(queryClient, savedState)
            } catch (error) {
                console.error("Failed to hydrate Vue Query cache", error)
            }
        }
    })

    // Persist the cached data in localStorage
    window.addEventListener("beforeunload", () => {
        try {
            const dehydratedState = dehydrate(queryClient)
            localStorage.setItem("vue-query", JSON.stringify(dehydratedState))
        } catch (error) {
            console.error("Failed to persist Vue Query cache", error)
        }
    })

})